import axiosInstance from "../config/axios";

export function documentCategoryForTradePdf(agreementType, classification) {
  const type = String(agreementType || "").toLowerCase();
  const cls = String(classification || "").toUpperCase();
  const isLease = type.includes("lease");
  if (isLease) {
    return cls.includes("CO-OPERAT") ? "lease-cooperating" : "lease-listing";
  }
  if (cls.includes("CO-OPERAT")) return "sale-cooperating";
  if (cls.includes("DOUBLE")) return "agent-double-ender";
  return "sale-listing";
}

export function documentItemForTradePdf(agreementType) {
  const type = String(agreementType || "").toLowerCase();
  if (type.includes("lease")) return "agreement-to-lease";
  return "agreement-purchase-sale";
}

function fileToBase64Chunk(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || "");
      const base64 = result.includes(",") ? result.split(",")[1] : result;
      resolve(base64 || "");
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function saveTradePdfToDocuments({
  tradeId,
  file,
  agreementType,
  classification,
}) {
  if (!tradeId || !file) return;
  const category = documentCategoryForTradePdf(agreementType, classification);
  const itemId = documentItemForTradePdf(agreementType);
  // Stay under nginx's ~1mb body limit (avoids 413 on DigiSign Form 101).
  const CHUNK_BYTES = 400 * 1024;
  const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_BYTES));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

  for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex += 1) {
    const start = chunkIndex * CHUNK_BYTES;
    const end = Math.min(file.size, start + CHUNK_BYTES);
    const chunkBase64 = await fileToBase64Chunk(file.slice(start, end));
    await axiosInstance.post(
      `/trade-documents/${tradeId}/files/chunk`,
      {
        uploadId,
        category,
        itemId,
        fileName: file.name || "document.pdf",
        mimeType: file.type || "application/pdf",
        chunkIndex,
        totalChunks,
        chunkBase64,
        fileSize: file.size,
        // Already validated on /pdf/parse — skip a second Claude form check.
        skipFormMatch: "true",
        source: "trade-pdf-parse",
      },
      { timeout: 180000 },
    );
  }
}
